import { ScaleApp } from "./scale"

export function useScaleApplication() {
  return ScaleApp.getInstance()
}
